<!--
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2024-04-21 13:45:15
 * @LastEditors: dudedu
 * @LastEditTime: 2024-04-23 11:51:19
-->
<template>
  <div id="app">
    <!-- <guac-client></guac-client> -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>
// import {getRequest} from '@/common/libs/request';
import Aegis from 'aegis-web-sdk';
import { autoInstance } from '@/common/libs/beacon';
import {getRequest} from "@/common/libs/request";
// import {RELEASE_JSON_URL} from "@/common/utils/utils";
export default {
  name: 'App',
  components: {
  },

  created() {
    // 获取项目价格黑名单
    getRequest('/api/common/getSetting?key=project_price_blacklist').then((res) => {
      sessionStorage.setItem('projectPriceBlacklist', res || '');
    });
    // 获取项目价格黑名单
    getRequest('/api/common/getSetting?key=multicloud_whitelist_add').then((res) => {
      sessionStorage.setItem('multicloudWhiteList', res || '');
    });
    this.performance();// 性能监控
    autoInstance.init().then(() => {
      console.log('beacon初始化成功');
    })
      .catch((err) => {
        console.log('beacon初始化失败', err);
      });
  },
  methods: {
    /**
     *性能监控
     * */
    performance() {
      // eslint-disable-next-line no-new
      new Aegis({
        // @ts-ignore
        id: process.env.VUE_APP_WEB_MONITOR_ID || '', // 应用ID，即上报key
        reportApiSpeed: true, // 接口测速
        reportAssetSpeed: true, // 静态资源测速
        spa: true, // spa 应用页面跳转的时候开启 pv 计算
        hostUrl: 'https://rumt-zh.com',
      });
    },

    /**
     * 获取维护信息
     * */
    // getMaintenanceInfo() {
    //   // postRequest('/api/eda/common/eda/getCosApi', {
    //   //   key: 'notice.json',
    //   //   dir: 'public',
    //   //   contentType: 'text/html',
    //   // })
    //   getRequest(`${RELEASE_JSON_URL}?${new Date().getTime()}`).then((res) => {
    //
    //   });
    // },

  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ul {
  list-style: none;
}

body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#tea-overlay-root {
  z-index: 9999 !important;
  position: relative;
}

</style>
